import {Component, inject, DestroyRef, computed, effect} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TrackTraceWidgetComponent} from "../../track-trace/track-trace-widget/track-trace-widget.component";
import {SearchWidgetComponent} from "../../invoices/search-widget/search-widget.component";
import {RevenueWidgetComponent} from "../../revenue/revenue-widget/revenue-widget.component";
import {UserModel} from "../../../core/user/user.model";
import {UserService} from "../../../core/user/services/user.service";
import {RevenueWidgetsService} from "../../../core/revenue/services/revenue-widget.service";
import {TargetWidgetComponent} from "../../revenue/target-widget/target-widget.component";
import {TrackingWidgetComponent} from "../../tracking/tracking-widget/tracking-widget.component";

@Component({
  selector: 'app-widget-area',
  imports: [
    TrackTraceWidgetComponent,
    SearchWidgetComponent,
    RevenueWidgetComponent,
    TargetWidgetComponent,
    TrackingWidgetComponent
  ],
  templateUrl: './widget-area.component.html',
  styleUrl: './widget-area.component.scss'
})

export class WidgetAreaComponent {
  public user: UserModel | null = null;
  private destroyRef = inject(DestroyRef);
  private revenueWidgetService: RevenueWidgetsService = inject(RevenueWidgetsService);
  protected userService: UserService = inject(UserService);

  hasTargetRxPackets = computed(() => {
    return this.revenueWidgetService.hasTargetRxPackets();
  });

  constructor(
  ) {
      effect(() => {
        const idf = this.userService.selectedIdf();
        if (idf) {
          this.revenueWidgetService.requestDashboardKpis(idf);
        }
      });

    this.userService.getUserResponseObservable().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((userResponse: any) => {
      if (userResponse !== undefined) {
        this.user = userResponse.user;
      }
    });
  }
  canAccessTile(authorities: any[]) {
    if (this.user) {
      if (this.userService.isAdmin()) {
        return true;
      }

      if (this.userService.isOwner()) {
        if (authorities.includes('PREISLISTE')) {
          if (!(this.user.authoritiesEnum.filter(value => authorities.includes(value)).length > 0)) {
            return false;
          }
        }
        return true;
      }

      if (this.user.authoritiesEnum.filter(value => authorities.includes(value)).length > 0) {
        return true;
      }
    }
    return false;
  }
}
